import http from './httpClient'
import { bffURL } from '../config'

export default class Postings {
  static getQuestions (postingId, idToken) {
    return http.get(`${bffURL}/postings/${postingId}/questions`, idToken).catch(e => (console.warn(`Failed to fetch questions: ${e}`)))
  }

  static getPosting (postingId, idToken) {
    return http.get(`${bffURL}/postings/${postingId}`, idToken).catch(e => (console.warn(`Failed to fetch posting: ${e}`)))
  }

  static getAlternativePosting (postingId, idToken) {
    return http.get(`${bffURL}/postings/${postingId}/alternative`, idToken).catch(e => (console.warn(`Failed to fetch alternative posting: ${e}`)))
  }

  static getAdditionalSteps (clientId, locationId, postingId, idToken) {
    return http.get(
      `${bffURL}/clients/${clientId}/locations/${locationId}/postings/${postingId}/steps`,
      idToken
    ).catch(e => (console.warn(`Failed to fetch additional steps: ${e}`)))
  }

  static getApplicantAdditionalSteps (jwt) {
    return http.get(
      `${bffURL}/application/steps`,
      jwt
    ).catch(e => (console.warn(`Failed to fetch additional steps: ${e}`)))
  }

  static getDisclosure (postingId, idToken) {
    return http.get(`${bffURL}/postings/${postingId}/disclosure`, idToken).catch(e => (console.warn(`Failed to fetch disclosure: ${e}`)))
  }

  static async resolvePostingUuid (uuid) {
    try {
      return await http.get(`${bffURL}/posting-uuid/${uuid}`)
    } catch (e) {
      return (console.warn(`Failed to resolve posting identifier: ${e}`))
    }
  }

  static async resolvePostingIdentifier (uuid) {
    try {
      return await http.get(`${bffURL}/posting-uuid/${uuid}`)
    } catch (e) {
      return (console.warn(`Failed to resolve posting identifier: ${e}`))
    }
  }
}
